import { action, makeObservable, observable } from 'mobx'
import { CheckTaxRefundDeliveryMethod } from '@taxfyle/api-internal/internal/tax_refund_methods_pb'
import PhysicalAddressEditorViewModel from '../../editors/PhysicalAddressEditorViewModel'

export default class CheckDeliveryMethodEditorViewModel {
  @observable useSameAddressAsContact = true

  readonly physicalAddressVm = new PhysicalAddressEditorViewModel()

  constructor() {
    makeObservable(this)
  }

  @action.bound
  validate() {
    if (this.useSameAddressAsContact) {
      return true
    }
    return this.physicalAddressVm.validate()
  }

  @action.bound
  reset(method?: CheckTaxRefundDeliveryMethod.AsObject) {
    const hasMailingAddress = !!method?.mailingAddress
    this.useSameAddressAsContact = !hasMailingAddress
    this.physicalAddressVm.reset(method?.mailingAddress)
  }
}
